var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLongArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 16,
    viewBox: "0 0 58 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.99121C0.447715 6.99121 -4.82823e-08 7.43893 0 7.99121C4.82823e-08 8.5435 0.447715 8.99121 1 8.99121L1 6.99121ZM57.7071 8.69831C58.0976 8.30779 58.0976 7.67462 57.7071 7.2841L51.3431 0.920139C50.9526 0.529614 50.3195 0.529615 49.9289 0.920139C49.5384 1.31066 49.5384 1.94383 49.9289 2.33435L55.5858 7.99121L49.9289 13.6481C49.5384 14.0386 49.5384 14.6718 49.9289 15.0623C50.3195 15.4528 50.9526 15.4528 51.3431 15.0623L57.7071 8.69831ZM1 8.99121L57 8.99121L57 6.99121L1 6.99121L1 8.99121Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongArrow);
export default __webpack_public_path__ + "static/media/longArrow.c36dfb32c77b337329dd84380b074c42.svg";
export { ForwardRef as ReactComponent };